import UpdatePasswordModal from '.';


export const loadUpdatePasswordModal = (jrConfigGlobal: Readonly<JrConfigGlobal> = window.jrConfigGlobal) => {
  if (!jrConfigGlobal.jobletter.jobseeker.registrationConfirmed || jrConfigGlobal.visit.requestComingFromWelcomeEmailAddPassword) {
    new UpdatePasswordModal(
      'confirm-subscription-modal',
      'jr-modal-wrapper',
      jrConfigGlobal,
    ).init();
  }
}
